import { apiGatewayService, ApiType } from "services/api/ApiGatewayService";

const PATH_REPORTS = "/api/v1/reports";

export interface CreateReportPublicLinkRequestDto {
    expiration?: string;
    language?: string;
}

export interface ReportPublicLinkResponseDto {
    expiration: string;
    link: string;
}

export interface CreateReportPublicLinksRequestDto extends CreateReportPublicLinkRequestDto {
    report_uuids: string[];
}

export interface ReportPublicLinksResponseDto {
    expiration: string;
    links: { report_uuid: string; link: string }[];
}

class ReportPublicLinkService {
    async createReportPublicLink(
        reportUuid: string,
        request: CreateReportPublicLinkRequestDto,
        abortController?: AbortController
    ): Promise<ReportPublicLinkResponseDto> {
        return apiGatewayService.invokeApi<CreateReportPublicLinkRequestDto, ReportPublicLinkResponseDto>(
            `${PATH_REPORTS}/${reportUuid}/public-link`,
            "POST",
            request,
            { abortSignal: abortController?.signal, apiType: ApiType.OLIVER }
        );
    }

    async createReportPublicLinks(
        reportUuids: string[],
        request: CreateReportPublicLinkRequestDto,
        abortController?: AbortController
    ): Promise<ReportPublicLinksResponseDto> {
        return apiGatewayService.invokeApi<CreateReportPublicLinksRequestDto, ReportPublicLinksResponseDto>(
            `${PATH_REPORTS}/public-links`,
            "POST",
            { ...request, report_uuids: reportUuids },
            { abortSignal: abortController?.signal, apiType: ApiType.OLIVER }
        );
    }
}

export const reportPublicLinkService = new ReportPublicLinkService();
